// Opções de bairro com a região como texto secundário (aparece e é pesquisável no Combobox).
export const withRegiao = (bairros = [], regioes = []) => {
  const byId = new Map(regioes.map((r) => [r.id, r.nome]));
  return bairros.map((b) => ({ ...b, sub: byId.get(b.regiao_id) || "" }));
};
